// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zzh_","toggle":"styles_toggle__2H3my","preview":"styles_preview__4fJCZ"};